module.exports = __webpack_public_path__ + "media/images/icons/illustration/betalen-13f429b498bc7071996e639d79fef15a.svg";